import React, { useState, useEffect } from 'react';

function Inicio() {
    const palavras = ["automaticamente", "instantaneamente", "colaborativamente", "juntos."];
    const [index, setIndex] = useState(0);
    const [texto, setTexto] = useState('');
    const [digitando, setDigitando] = useState(true);
    const [exibirCursor, setExibirCursor] = useState(true);
    const [pausado, setPausado] = useState(false);

    useEffect(() => {
        let timeout;

        if (!pausado) {
            if (digitando) {
                if (texto.length < palavras[index].length) {
                    timeout = setTimeout(() => {
                        setTexto(palavras[index].slice(0, texto.length + 1));
                    }, 100);
                } else {
                    if (index === palavras.length - 1) {
                        setTimeout(() => {
                            setExibirCursor(false);
                            setPausado(true);
                            setTimeout(() => {
                                setTexto('');
                                setIndex(0);
                                setDigitando(true);
                                setExibirCursor(true);
                                setPausado(false);
                            }, 30000); // Pausa de 30 segundos
                        }, 1000);
                    } else {
                        setTimeout(() => setDigitando(false), 1000);
                    }
                }
            } else {
                if (texto.length > 0) {
                    timeout = setTimeout(() => {
                        setTexto(texto.slice(0, -1));
                    }, 50);
                } else {
                    setDigitando(true);
                    setIndex(index + 1);
                }
            }
        }

        return () => clearTimeout(timeout);
    }, [texto, digitando, index, pausado]);

    return (
        <section id="inicio">
            <div className="container-fluid">
                <div className="inicio"></div>
                <div className="row">
                    <div className="col-lg-6">
                        <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active" data-bs-interval="9999">
                                    <img src="Images/Notbook.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-inicio.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-lacamentos.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-lacamentos-mais.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-estoque.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-nfs.png" className="d-block w-100" alt="..." />
                                </div>
                                <div className="carousel-item">
                                    <img src="Images/Notbook-drive.png" className="d-block w-100" alt="..." />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <h2 className="chamado-h2">Vamos cuidar da sua empresa daqui,</h2>
                        <h2 className="chamado2-h2">
                            {texto}
                            {exibirCursor && <span className="cursor">|</span>}
                        </h2>
                        <h4 className="chamado3-h4">A plataforma de gestão financeira e assessoria contábil online.</h4>
                        <a href="https://wcontec.osayk.com.br/#/cadastro" className="btn btn-success btn-lg btn-chamado zoom-img">Cadastre-se</a>
                        <a href="https://wcontec.osayk.com.br/#/login" className="btn btn-outline-primary btn-lg btn-chamado zoom-img">Acessar</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Inicio;
